import { Injectable } from '@angular/core';
import { Platform } from 'ionic-angular';
import { LoggerProvider, LoggerLevel, LoggerEvent } from '../logger/logger';
import { ProfileNotification } from '../../model/types/profile-notification-type';


@Injectable()
export class ProfileNotificationProvider {

  static profileNotification: ProfileNotification[] = []; // for showing the badge on the profile icon and on the profile list

  constructor(
    private platform: Platform
    ) { }

  static addProfileNotification(notification: ProfileNotification) {
    if (ProfileNotificationProvider.profileNotification.indexOf(notification) > -1)
      return;
      ProfileNotificationProvider.profileNotification.push(notification);
  }

  static removeProfileNotification(notification: ProfileNotification) {
    const index = ProfileNotificationProvider.profileNotification.indexOf(notification);
    if (index > -1)
      ProfileNotificationProvider.profileNotification.splice(index, 1);
  }

  static hasProfileNotification(notification: ProfileNotification | null = null) {
    if(notification)
      return ProfileNotificationProvider.profileNotification.indexOf(notification) > -1;
    return ProfileNotificationProvider.profileNotification.length > 0;
  }

  static logout() {
    ProfileNotificationProvider.profileNotification = [];
  }

}



// WEBPACK FOOTER //
// ./src/providers/profile-notification/profile-notification.ts